// src/departments/useDepartments.ts

import { useDepartmentService } from '@/api/services/departmentService';
import { useMutation, useQueryClient } from '@tanstack/react-query';

/**
 * Custom hook for deleting a department.
 * @param {string} orgId - The ID of the organization, used for query invalidation.
 */
export function useDeleteDepartment(orgId: string) {
  const queryClient = useQueryClient();
  const departmentService = useDepartmentService();

  return useMutation({
    mutationFn: (departmentId: string) =>
      departmentService.delete(departmentId),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ['organization', orgId, 'departments'],
      });
    },
  });
}
